export enum LoyaltyType {
  discountFirstPurchase = 'WelcomeDiscountForFirstPurchase',
  discountSecondPurchase = 'WelcomeDiscountForSecondPurchase',
}
